const colors = {
  default: { h: 0, s: 0, l: 10 },
  black: '#191919',
  defaultGray: '#333',
  gray: '#777',
  mediumGray: '#aaa',
  lightGray: '#d1d2d4',
  hairlineGray: '#eee',
  label: '#777',
  marker: '#555',
  correlation: [
    { h: 140, s: 53, l: 41 },
    { h: 140, s: 36, l: 52 },
    { h: 140, s: 36, l: 64 },
    { h: 140, s: 36, l: 76 },
    { h: 139, s: 37, l: 88 },
    { h: 0, s: 84, l: 93 },
    { h: 0, s: 84, l: 85 },
    { h: 0, s: 84, l: 77 },
    { h: 0, s: 84, l: 70 },
    { h: 0, s: 84, l: 63 }
  ]
}

export function hslToString(h, s, l) {
  return `hsla(${h}, ${s}%, ${l}%, 1)`
}

export function getCorrelationFill(correlation, desaturated = false) {
  // `correlation` is a number between -1 and 1 inclusive used to
  // interpolate between red and green in steps to determine the fill
  // for a data point in a correlation matrix

  const index = Math.ceil(((Number(correlation) + 1) / 2) * 10) - 1

  if (index < 0 || index > 9) {
    throw new Error('index out of bounds: ' + index)
  }

  const { h, s, l } = colors.correlation[index]

  return hslToString(h, desaturated ? 0 : s, l)
}

/**
 * Source: https://gist.github.com/mjackson/5311256
 */
export function hslToHex(h, s, l) {
  h /= 360
  s /= 100
  l /= 100
  let r, g, b
  if (s === 0) {
    r = g = b = l // achromatic
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1
      if (t > 1) t -= 1
      if (t < 1 / 6) return p + (q - p) * 6 * t
      if (t < 1 / 2) return q
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
      return p
    }
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s
    const p = 2 * l - q
    r = hue2rgb(p, q, h + 1 / 3)
    g = hue2rgb(p, q, h)
    b = hue2rgb(p, q, h - 1 / 3)
  }
  const toHex = x => {
    const hex = Math.round(x * 255).toString(16)
    return hex.length === 1 ? '0' + hex : hex
  }
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`
}

export default colors



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/colors.js